import * as time from "./time.js";

/**
  Return unit type based on key (e.g. pushups: reps | cycling: km)
*/
export function getUnitType(keyname: string): string {
  return window.config.unitType[keyname] || "";
}

/**
  Return formatted unit type (ie. for time: seconds or HM)
*/
export function showUnit(val: number, unit = ""): string {
  unit = getUnitType(unit);
  switch (unit) {
    case "time":
      val = val >= 60 ? time.minsToHM(val) : val;
      break;
    case "secs":
      val = val >= 60 ? time.secsToMins(val) : val;
      break;
    case "weight":
      unit = "kg";
      break;
    case "distance":
      unit = "km";
      break;
  }
  return `${val} ${unit}`;
}

export function val(expression, unit_pre = "", unit_post = "", blank = "nothing yet") {
  expression = expression ? expression : blank;
  return `<val>${unit_pre} ${expression} ${unit_post}</val>`;
}
